import humanizeDuration from 'humanize-duration';
import moment from 'moment';

export const getHumanSavedAt = (
  finished = false,
  modified = new Date().getTime(),
  composition,
  errorAt,
  loadingSaveComposition,
) => {
  if (!composition) {
    return 'Carregando...';
  }

  if (errorAt > composition.get('modified')) {
    return 'Erro ao salvar, tentando novamente...';
  }

  if (loadingSaveComposition) {
    return 'Salvando...';
  }

  if (!finished) {
    return `Salvo há ${humanizeDuration(new Date().getTime() - modified, {
      language: 'pt',
      round: true,
      largest: 1,
    })}`;
  }

  return `Salvo no dia ${moment(
    composition.get('modified') || composition.get('created'),
  ).format('DD/MM/YYYY')} - ${moment(
    composition.get('modified') || composition.get('created'),
  ).format('hh:mm')}`;
};
